<template>
  <div class="content">
    <div class="days-risk">
      <!-- <div class="p-time">监测时间：{{ $moment(riskShort.ddatetime).format('YYYY-MM-DD HH:mm')}}</div> -->
      <div class="risk-list">
        <div class="risk-item">
          <span>要素/日期</span>
          <span
            v-for="(item, index) in riskResult.times"
            :key="index + ''"
            v-html="item"
          ></span>
        </div>
        <div class="risk-item">
          <span>空气质量</span>
          <span
            v-for="(quality, index) in riskResult.quality"
            :key="'quality' + index"
          >
            {{ quality }}
          </span>
        </div>
        <div class="risk-item">
          <span>首要污染物</span>
          <span
            v-for="(pollutant, index) in riskResult.pollutant"
            :key="'pollutant' + index"
          >
            {{ pollutant }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  props: ["params", "forecastType"],
  data() {
    return {
      riskType: 0,
      riskShort: {},
      riskFore: {},
      levelMap: {
        1: "高",
        2: "中",
        3: "低",
      },
    };
  },

  watch: {
    riskShortResult(id) {
      setTimeout(() => {
        this.getRiskData();
      }, 100);
    },
    riskForeResult(id) {
      setTimeout(() => {
        this.getRiskData();
      }, 100);
    },
    tqskDateResult: {
      handler() {
        setTimeout(() => {
          this.getRiskData();
        }, 100);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("home", [
      "objsList",
      "activeCountyId",
      "cartData",
      "airQualityDataResult",
      "riskShortResult",
    ]),
    riskResult() {
      const result = {
        times: [],
        quality: [],
        pollutant: [],
      };
      if (this.riskFore && this.riskFore.quality) {
        result.times = this.riskFore.time;
        result.quality = this.riskFore.quality;
        result.pollutant = this.riskFore.pollutant;
      }
      return result;
    },
  },
  mounted() {
    setTimeout(() => {
      this.getRiskData();
    }, 100);
  },
  methods: {
    ...mapMutations("home", ["changeCartItem"]),
    /**
     * 短临风险
     */
    async getRiskData() {
      this.riskFore = this.airQualityDataResult;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.8vw 1.04vw 1.04vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;

  .short-risk {
    height: 100%;
    // padding: 10% 8% 4% 8%;
    // padding: 3.13vw 1.04vw 1.04vw 1.04vw;
    box-sizing: border-box;
  }

  .days-risk {
    height: 100%;
    // padding: 10% 8% 4% 8%;
    // padding: 3.13vw 1.04vw 1.04vw 1.04vw;
    box-sizing: border-box;
    // width: 38.31rem;
  }

  .risk-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .risk-item {
      font-size: 0.88rem;
      color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 0.6vw;

      &:hover {
        cursor: pointer;
      }

      span:nth-child(1) {
        text-align: center;
        width: 3.64vw;
      }

      span {
        width: 74px;
        display: inline-block;
        text-align: center;
        margin: 0vw 0.16vw;
        white-space: nowrap;
        i {
          display: inline-block;
          position: relative;
          width: 3.27rem;
          height: 0.63rem;
          //background: #295073;
          background: #3a678f;
          border-radius: 0.31rem;

          &:hover {
            .pounp {
              display: block;
            }
          }

          .pounp {
            display: none;
            position: absolute;
            bottom: 0.8vw;
            left: 50%;
            transform: translateX(-50%);
            width: 3.27rem;
            height: 1.36vw;
            line-height: 1.36vw;
            background: #052c4d;
            color: #fff;
            box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;

            &::after {
              content: "";
              display: inline-block;
              position: absolute;
              left: 50%;
              bottom: -10px;
              transform: translateX(-50%);
              border: 5px solid transparent;
              border-top-color: rgba(255, 255, 255, 0.8);
              box-shadow: 0px 2px 18px 0px rgba(139, 157, 189, 0.35);
            }
          }
        }
      }
    }

    .risk-item:nth-child(1) {
      height: 2.14vw;
      background: #052c4d;
      border-radius: 0.21vw;
    }
  }
}
</style>
